import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, } from 'react';
const SchemaBuilderRowContext = createContext({
    propertiesRef: null,
    setPropertiesRef: () => { },
});
export function SchemaBuilderRowContextProvider({ children }) {
    const [propertiesRef, setPropertiesRef] = useState(null);
    const value = {
        propertiesRef,
        setPropertiesRef,
    };
    return (_jsx(SchemaBuilderRowContext.Provider, { value: value, children: children }));
}
export function useSchemaBuilderRowContext() {
    return useContext(SchemaBuilderRowContext);
}
//# sourceMappingURL=row-context.js.map